<template>
  <v-container class="main d-flex justify-center" style="max-width:600px">
    <div v-if="step === 1" class="main2 d-flex flex-column align-center" style="height:100vh">
      <div class="mt-10 mb-4 font-weight-bold" style="text-indent:2em">{{$t('lang.Information')}}<span style="color:red">{{$t('lang.verificationSuccessful')}}</span>{{$t('lang.staffVerification')}}</div>
      <div class="certificate d-flex flex-column align-center">
        <div class="d-flex flex-column align-center" style="height:75%;width:100%">
          <div class="corp-title-text"><div class="corp-title-text2 d-flex justify-center align-center font-weight-black" style="color: rgb(133, 182, 16);">{{$t('lang.ConferencePass')}}</div></div>
          <div class="font-weight-black mt-4 mx-3" style="color: rgb(198, 236, 84);">{{$store.getters.getLanguage === 0 ? $store.getters.getData.Subject : $store.getters.getData.EnglishSubject}}</div>
          <div class="pa-4 white--text d-flex flex-column justify-end" style="height:100%;width:100%">
            <div class="mx-2">{{$t('lang.name')}}：{{ obj.UserName }}</div>
            <div class="mx-2 my-1">{{$t('lang.phoneOrEmail')}}：{{ obj.Phone }}</div>
            <div class="mx-2">{{$t('lang.Organization')}}：{{ obj.Company }}</div>
          </div>
        </div>
        <div style="height:23%;width:96%;background: rgba(0,0,0,0.1);border-bottom-left-radius: 15px;border-bottom-right-radius: 15px;">
          <div v-if="$store.getters.getLanguage === 0" style="height:50%" class="pt-2 d-flex justify-center align-center white--text text-center">第<span class="mx-2 text-h6 d-flex justify-center align-center" style="width:25px;height:25px;border-radius: 50%;background: rgba(0,0,0,0.4);">{{ obj.SignInTimes }}</span>次签到</div>
          <div v-else style="height:50%" class="pt-2 d-flex justify-center align-center white--text text-center">Sign in for the <span class="mx-2 text-h6 d-flex justify-center align-center" style="width:25px;height:25px;border-radius: 50%;background: rgba(0,0,0,0.4);">{{ obj.SignInTimes }}</span>time</div>
          <div style="height:50%" class="d-flex justify-center align-center white--text text-body-2">{{$t('lang.SignInTime')}}：{{ SignInTime }}</div>
        </div>
      </div>
      <div class="text-center my-6" style="color: rgb(169, 168, 168);">{{$t('lang.staff')}}</div>
      <v-row style="width:100%">
        <v-col cols="6">
          <v-btn block large color="rgb(234, 234, 234)" style="text-transform:none; color: rgb(153, 153, 153);" @click="back()">{{$t('lang.back')}}</v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn block large color="primary" style="text-transform:none;" :loading="loading" @click="next()">{{$t('lang.confirm')}}</v-btn>
        </v-col>
      </v-row>
    </div>
    <div v-if="step === 2" class="main2 d-flex flex-column" style="height:100vh">
      <div class="mt-10" style="color: rgb(138, 195, 243);">{{$t('lang.warmPrompt')}}</div>
      <div v-if="$store.getters.getLanguage === 0" class="mt-10 mb-4 font-weight-bold" style="text-indent:2em">抱歉，
        <span v-if="ret === 8">您的签到次数已用完，本次</span>
        <span v-else-if="ret === 1">您输入的签到信息验证不成功，本次</span>
        <span style="color:red">签到失败</span> ，若有疑问请联系现场工作人员。
      </div>
      <div v-else class="mt-10 mb-4 font-weight-bold" style="text-indent:2em">Sorry,
        <span style="color:red">sign-in faild. </span>
        <span v-if="ret === 8">Your sign-in times have been used up.</span>
        <span v-else-if="ret === 1">Your information verification is unsuccessful, </span>
         If you have any questions, please contact the on-site staff,Thank you!
      </div>
      <v-row v-if="$store.getters.getLanguage === 0" class="mt-10" style="width:100%">
        <v-col cols="5">
          <v-btn block large color="rgb(234, 234, 234)" style="text-transform:none; color: rgb(153, 153, 153);" @click="step = 1">{{$t('lang.back')}}</v-btn>
        </v-col>
        <v-col cols="7">
          <v-btn block large color="primary" style="text-transform:none;" @click="loginAgain()">{{$t('lang.signAgain')}}</v-btn>
        </v-col>
      </v-row>
      <div v-else>
        <v-btn block large color="rgb(234, 234, 234)" style="text-transform:none; color: rgb(153, 153, 153);" @click="step = 1">{{$t('lang.back')}}</v-btn>
        <v-btn block large color="mt-10 primary" class="text-body-2" style="text-transform:none;" @click="loginAgain()">{{$t('lang.signAgain')}}</v-btn>
      </div>
    </div>
    <v-snackbar v-model="snackbar" timeout="2000" centered color="primary" multi-line>
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          {{$t('lang.close')}}
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="dialog" persistent max-width="290" transition="dialog-top-transition">
      <v-card class="d-flex flex-column justify-center align-center" style="min-height:200px;background: #1D76D0;">
        <v-card-text class="mb-6 white--text text-center text-subtitle-1">{{$t('lang.Confirmed')}}</v-card-text>
        <div style="width:80%">
        <v-btn block outlined color="rgb(158, 206, 255)"  @click="dialog = false;">
          {{$t('lang.close')}}
        </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style>
  .main2 {
    width: 90%;
  }
  .certificate {
    border-radius: 15px;
    border: 2px solid rgba(14, 5, 10, 0.2);
    border-collapse: separate;
    border-spacing: 10px;
    background-image: url('../assets/sign_background.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 96% 96%;
    height: 50vh;
    width: 80%;
  }
  @media screen and (min-width: 500px) and (min-height: 800px) {
    .main {
        border-left: 1px solid rgb(243, 243, 245);
        border-right: 1px solid rgb(243, 243, 245);
        line-height: 2em;
        font-size: 20px;
    }
    .main2 {
      width: 70%;
    }
    .certificate {
      height: 45vh;
    }
}
  @media screen and (min-width: 500px) and (max-height: 800px) {
    .main {
        border-left: 1px solid rgb(243, 243, 245);
        border-right: 1px solid rgb(243, 243, 245);
        line-height: 2em;
        font-size: 20px;
    }
    .main2 {
      width: 70%;
    }
    .certificate {
      height: 55vh;
    }
}
  .corp-title-text{
    width: 60%;
    height: 40px;
    position: relative;
    background: white;
    border-bottom: 5px solid white;
    border-bottom-left-radius: 2em;
    border-bottom-right-radius: 2em;
    clip-path:polygon(0 0, 20px 100%,calc(100% - 20px) 100%,100% 0);
    box-sizing: border-box;
  }
  .corp-title-text2{
    padding: 0 10px;
    margin-top: 5px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: white;
    clip-path:polygon(1px 0, 11px 100%,calc(100% - 11px) 100%,calc(100% - 1px) 0);
  }

</style>
<script>
import utils from '../utils/utils.js'
export default {
  name: 'Checkin',
  props: ['data'],
  data () {
    return {
      snackbar: false,
      dialog: false,
      loading: false,
      step: 0,
      ret: 0,
      msg: '',
      obj: {}
    }
  },
  computed: {
    SignInTime () {
      return this.$store.getters.getLanguage === 0 ? this.obj.SignInTime : utils.methods.getEnglishDate(this.obj.SignInTime)
    }
  },
  mounted () {
    if (this.$store.getters.getLanguage === 1) {
      this.$i18n.locale = 'en-US'
      // this.$store.commit('setLanguage', 1)
    } else {
      this.$i18n.locale = 'zh-CN'
      // this.$store.commit('setLanguage', 0)
    }
    document.title = this.$store.getters.getLanguage === 0 ? this.$store.getters.getData.Subject : this.$store.getters.getData.EnglishSubject
    this.query()
  },
  methods: {
    query () {
      this.$http.get('/SignUp/LoadUserSignInInfo', {
        requestBase: 'VUE_APP_API',
        params: {
          input: this.$store.getters.getUserSignUpId
        }
      }).then(res => {
        console.log(res)
        if (res.data.ret === 0) {
          this.step = 1
          this.obj = res.data
        } else if (res.data.ret === 1) {
          this.step = 2
          this.ret = res.data.ret
        } else {
          this.msg = res.data.msg
          this.snackbar = true
        }
      }).catch(e => {
        this.msg = 'error'
        this.snackbar = true
        console.log(e)
      })
    },
    back () {
      if (utils.methods.isMobile()) {
        this.$store.commit('setBackFromCheckin', true)
        this.$router.go(-1)
      } else {
        window.opener = null
        window.open('about:blank', '_top').close()
      }
    },
    next () {
      this.loading = true
      this.$http({
        method: 'post',
        requestBase: 'VUE_APP_API',
        url: '/SignUp/UserSignIn',
        params: {
          input: this.$store.getters.getUserSignUpId
        }
      }).then(res => {
        console.log(res)
        this.loading = false
        if (res.data.ret === 0) {
          this.dialog = true
        } else if (res.data.ret === 1 || res.data.ret === 8) {
          this.step = 2
          this.ret = res.data.ret
        }
      }).catch(e => {
        this.msg = 'error'
        this.snackbar = true
        console.log(e)
      })
    },
    loginAgain () {
      if (utils.methods.isMobile()) {
        this.$store.commit('setLogin', false) // 手机端不是新打开一个浏览器tab标签，所以需要在这里设置登录失效
        this.$store.commit('setLogin4SignAgain', true)
      }
      localStorage.setItem('zheng', new Date())
      this.back()
    }
  }
}
</script>
